<template>
  <model-table
    :data="ractivities"
    :noItemLabel="$t('compCarbonFormsRactivitiesTable.no-ractivity')"
    :module="module"
    :detailed="true"
    :custom-detail-row="true"
    :disabled="isSubmitted"
    :singleUpdateDisabled="false"
    :bulkOpsDisabled="false"
    :withTags="authStore.isAuthenticated"
    @update="$emit('update')"
    @edit="(item) => $emit('edit', item)"
    @del="(items) => $emit('del', items)"
  >
    <b-table-column
      :label="$t('compCarbonFormsRactivitiesTable.label-5')"
      field="category"
      sortable
      v-slot="props"
    >
      {{ $t(props.row.category) }}
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsRactivitiesTable.label-1')"
      field="type"
      sortable
      v-slot="props"
    >
      {{ $t(props.row.type) }}
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsRactivitiesTable.label-2')"
      field="subtype"
      v-slot="props"
    >
      {{ getDescription(props.row) }}
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsRactivitiesTable.label-3')"
      field="amount"
      sortable
      numeric
      :custom-sort="sortAmount"
      v-slot="props"
    >
      {{ formatAmount(props.row.amount) }}
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsRactivitiesTable.label-4')"
      sortable
      v-slot="props"
    >
      {{ $t(props.row.getUnit()) }}
    </b-table-column>
    <template slot="detail" slot-scope="props">
      <tr
        v-for="(item, index) in props.props.row.items"
        :key="Math.floor(Math.random() * 100000000) + index"
      >
        <td v-if="authStore.isAuthenticated" />
        <td />
        <td />
        <td />
        <td class="has-text-left">{{ $t(item.category) }}</td>
        <td class="has-text-left">{{ $t(item.type) }}</td>
        <td class="has-text-left">{{ getDescription(item) }}</td>
        <td class="has-text-right">{{ formatAmount(item.amount) }}</td>
        <td class="has-text-left">{{ $t(item.getUnit()) }}</td>
        <td class="has-text-centered"></td>
      </tr>
    </template>
  </model-table>
</template>

<script>
import Modules from '@/models/Modules.js'
import { researchActivityClass } from '@/models/carbon/ResearchActivity.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'Table',
  setup () {
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { ghgiStore, authStore }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue')
  },
  computed: {
    module: function () {
      return Modules.RACTIVITIES
    },
    ractivities: function () {
      var activities = this.ghgiStore.items(Modules.RACTIVITIES)
      var activitiesConcat = []
      activities.forEach((activity) => {
        if (activity.isGrouped) {
          var headerRowIndex = activitiesConcat
            .map((obj) => obj.type)
            .indexOf(activity.type)
          if (headerRowIndex === -1) {
            activitiesConcat.push(
              researchActivityClass(activity.type).headerRow
            )
            activitiesConcat[activitiesConcat.length - 1].items.push(activity)
          } else {
            activitiesConcat[headerRowIndex].items.push(activity)
          }
        } else {
          activitiesConcat.push(activity)
        }
      })
      return activitiesConcat
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    }
  },
  methods: {
    sortAmount: function (a, b, isAsc) {
      if (isAsc) {
        return Number(a.amount) - Number(b.amount)
      } else {
        return Number(b.amount) - Number(a.amount)
      }
    },
    getDescription: function (row) {
      if (row.items.length) {
        var desc = row.items[0].subtype
        for (let i = 1; i <= Math.min(4, row.items.length - 1); i++) {
          desc = desc.concat(', ', row.items[i].subtype)
        }
        desc = desc.concat('...')
        return desc
      } else {
        let cclass = researchActivityClass(row.type)
        return cclass.getDescription(
          row.category,
          row.type,
          row.subtype,
          this.$i18n.locale
        )
      }
    },
    formatAmount: function (amount) {
      if (!amount && amount !== 0) {
        return ' '
      } else {
        return Number(Number(amount).toFixed(2))
      }
    }
  }
}
</script>
